import script from "./OrderDetailEmbed.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailEmbed.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetailEmbed.vue?vue&type=style&index=0&id=1c6bfc9a&lang=css"

const __exports__ = script;

export default __exports__